import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store/index';
import { StoreKey } from '@/configs/storeKeys';
import {
	CreatorOptions,
	CreatorState,
	CreatorStep,
	ViewType,
	LayerType,
} from '@/types/creator';

const initialState: CreatorState = {
	options: {
		currentStep: CreatorStep.CONFIGURATION,
		isProductTypeInfoOpened: false,
		viewType: ViewType['2D'],
		layerType: LayerType.EXTERNAL,
		isSideView: false,
		selectedDecor: null,
	},
};

export const creatorSlice = createSlice({
	name: StoreKey.CREATOR,
	initialState,
	reducers: {
		setCreatorStep: (state, { payload }: PayloadAction<'prev' | 'next'>) => {
			payload === 'prev'
				? state.options.currentStep--
				: state.options.currentStep++;
		},
		updateOptions: (
			state,
			{ payload }: PayloadAction<Partial<CreatorOptions>>
		) => {
			Object.assign(state.options, payload);
		},
		resetCreator: (state) => {},
	},
});

export const creatorActions = creatorSlice.actions;

export const selectCreatorState = (state: RootState) => state.creator;
export default creatorSlice.reducer;
